import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { RequestData } from 'src/app/common/models/request-data.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionUpdaterService {

  constructor(private http: HttpClient) { }

  getVersionList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/updater/get', requestData);
  }

  /**
   * Get shops using a specific version
   * @param updatedVersion - Version string (e.g., "1.6.1")
   * @returns Observable with shops data
   */
  getShopsByVersion(updatedVersion: string): Observable<any> {
    const url = environment.baseUrl + '/updater/shops/' + updatedVersion;
    return this.http.get(url);
  }

  /**
   * Get shops using a specific version with filtering
   * @param updatedVersion - Version string (e.g., "1.6.1")
   * @param filters - Search filters object
   * @returns Observable with filtered shops data
   */
  getShopsByVersionWithFilters(updatedVersion: string, filters: any): Observable<any> {
    const url = environment.baseUrl + '/updater/shops/' + updatedVersion;
    return this.http.post(url, { filters: filters });
  }

  /**
   * Get terminals list for a specific shop and version
   * @param shopId - Shop ID
   * @param version - Version string
   * @returns Observable with terminals data
   */
  getTerminalsByShop(shopId: string, version: string): Observable<any> {
    const url = environment.baseUrl + '/updater/terminals/' + shopId + '/' + version;
    return this.http.get(url);
  }

  /**
   * Save terminal assignments for version update
   * @param payload - Terminal assignment payload
   * @returns Observable with save response
   */
  saveTerminalAssignments(payload: any): Observable<any> {
    const url = environment.baseUrl + '/updater/update-terminals';
    return this.http.post(url, payload);
  }

  /**
   * Get assigned shops for a specific version
   * @param version - Version string (e.g., "1.6.1")
   * @returns Observable with assigned shops data
   */
  getAssignedShopsForVersion(version: string): Observable<any> {
    const url = environment.baseUrl + '/updater/assigned-shops/' + version;
    return this.http.get(url);
  }

  /**
   * Update assigned shops for a specific version
   * @param payload - Shop assignment payload {versionNo: string, shopsList: number[]}
   * @returns Observable with update response
   */
  updateAssignedShops(payload: any): Observable<any> {
    const url = environment.baseUrl + '/updater/update-assigned-shops';
    return this.http.post(url, payload);
  }

  /**
   * Get folder details by folder path
   * @param payload - Folder path payload {folderPath: string}
   * @returns Observable with folder details response
   */
  getFolderDetails(payload: any): Observable<any> {
    const url = environment.baseUrl + '/updater/folder-details';
    return this.http.post(url, payload);
  }

  /**
   * Save or update version details
   * @param payload - Version data payload
   * @returns Observable with save response
   */
  saveUpdateVersion(payload: any): Observable<any> {
    const url = environment.baseUrl + '/updater/save-update-version';
    return this.http.post(url, payload);
  }

  // /**
  //   * 
  //   * @param areaInfo 
  //   * Calls the API to delete the record
  //   */
  // delete(areaInfo: AreaModel): Observable<any> {
  //   return this.http.post(environment.baseUrl + '/area/delete/' + areaInfo.id, areaInfo);
  // }

}
